import { useDispatch } from "react-redux";
import { onChangeParticipationRequirement, setPolicyInformationType } from "../../../../../features/ebam/plicy-data-page/policy-information/policy-information.slice";
import EditSaveCancelButtons from "../../../../ui/edit-save-cancel-buttons";
import Input from "../../../../ui/input";
import { usePolicyActions } from "../../../../../hooks/actions/use-policy-actions";
import PolicyContentHeaderAction from "./policy-content-header-action";
import { usePolicyDataState } from "../../../../../hooks/policy/use-policy-data-state";

interface Props {
    isShow: boolean;
}

export default function PolicyInformationParticipation({ isShow }: Props) {

    const dispatch = useDispatch()
    const { isPIParticipationRequirements, policyParticipationRequirements, } = usePolicyDataState()
    const { handleEditPolicyInformation, isLoadingUpdatePolicy, handleCancelEditPolicyInformation } = usePolicyActions()
    
    if (!isShow) {
        return null;
    }

    return (
        <div className="overflow-x-auto rounded border border-gray-200">
            <table className="w-full min-w-[600px] border-collapse text-xs">
                <thead>
                    <tr className="bg-[#eef6fc]">
                        <th colSpan={2} className="border-b border-[#c7e0f3] px-3 py-2 text-left text-[#186cb2] sm:px-4 sm:py-2.5" >
                            {/* Participation Requirements */}
                            <div className="flex flex-row items-start justify-between gap-2 md:gap-4 font-normal">
                                <PolicyContentHeaderAction
                                    title='Participation Requirements'
                                    subTitle='Enter the eligibility criteria or description. You can use bullets, numbering, and basic text formatting'
                                />
                                <EditSaveCancelButtons
                                    isEditing={!isPIParticipationRequirements}
                                    onEdit={() => dispatch(setPolicyInformationType("participationRequirements"))}
                                    onCancel={handleCancelEditPolicyInformation}
                                    onSave={() => handleEditPolicyInformation('participationRequirements')}
                                    isLoading={isLoadingUpdatePolicy}
                                />
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {policyParticipationRequirements.map((data) => {
                        const hasPercentage = data.id === 1;
                        const isNumber = data.id === 1;
                        return (
                            <tr key={data.id}>
                                <td className="border-b border-r border-gray-200 px-3 py-2 text-gray-600 sm:px-4">
                                    {data.title}
                                </td>
                                <td className="border-b border-gray-200 px-2 py-2 text-gray-600">
                                    <div className={`flex overflow-hidden rounded-md border focus-within:border-[#186cb2] border-gray-300`} >
                                        <Input
                                            type={isNumber ? "number" : "text"}
                                            name={`participationRequirement-${data.id}`}
                                            value={data.amount}
                                            isCustomStyle={true}
                                            customCss={`w-full rounded-tr rounded-br px-3 py-2 text-xs outline-none ${
                                                !data.amount ? "" : "bg-[#186cb2]/10"
                                            }`}
                                            // customCss={`${defaultStyle} ${data.amount ? "" : customStyle} ${ data.amount ? "bg-gray-100" : ""}`}
                                            onChange={(e) => { dispatch(onChangeParticipationRequirement({ id: data.id, amount: e.target.value, }))}}
                                            required={true}
                                            disabled={!isPIParticipationRequirements}
                                        />
                                        {hasPercentage && (
                                            <div className="relative">
                                                <button
                                                    type="button"
                                                    disabled
                                                    className="flex w-full items-start justify-between border-r bg-[#186cb2]/10 px-3 py-[8px] text-xs disabled:cursor-not-allowed"
                                                >
                                                    <span className="flex-1 text-left font-bold">
                                                        %
                                                    </span>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    )
}
